import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StyledParagraph } from '../styledComponents/StyledText'
import { emailValidate } from '../utils/validateInputs.js'
import { theme } from '../utils/theme'

export const StyledInputLabel = styled.label`
  font-family: Lato;
  font-size: 12px;
  line-height: 18px;
  color: ${props => props.isActive ? props.theme.colors.primary : props.theme.colors.soilGray};
  margin-bottom: 0px;
  margin-left: 5px;
  letter-spacing: 0.4px;
`

export const StyledFormInputContainer = styled.div`
  width: 100%;
  align-self: center;
  position: relative;
`

export const StyledFieldInput = styled.input`
  min-width: 100%;
  border: none;
  border-bottom: 1px ${props => props.error ? props.theme.colors.warning : props.isActive ? '#2EC4B2' : '#767573'} solid;
  padding: 0 16px;
  padding-bottom: 10px;
  font-family: Lato;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  align-self: flex-end;
  outline: none;
  color: ${props => props.theme.colors.nearBlack};
  background: none;
  padding-right: ${props => props.showAddon ? '45px' : '16px'};
`

export const StyledInputAddon = styled.button`
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  border: none;
  right: 10px;
  padding: 0;
  bottom: 10px;
  outline: none;
  &:focus {
    outline: none;
  }
`

export const StyledInputField = (props) => {
  const {
    overrideStyles,
    overrideClassName,
    label,
    error,
    value,
    placeholder,
    onChange,
    name,
    required,
    type,
    validate,
    addon,
    onIconClick,
    updateFormError,
    input,
    triggerSubmit
  } = props
  const [validationError, setError] = useState('')
  const [isActive, highlightInput] = useState(false)

  const validateField = () => {

    highlightInput(false)
    if (required) {
      if (!value || value.trim().length === 0) {
        updateFormError({ [name]: 'Field is Required' })
        return setError('Field is Required')
      } else if (validate && validate.length) {
        for (let func of validate) {
          const validationError = func(value)
          if (validationError) {
            updateFormError({ [name]: validationError })
            setError(validationError)
            break
          } else {
            updateFormError({ [name]: null })
            setError('')
          }
        }
      } else if (type === 'email') {
        updateFormError({ [name]: emailValidate(value) })
        return setError(emailValidate(value))
      } else {
        updateFormError({ [name]: null })
        setError('')
      }

    }
  }

  const onkeyPressed = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      triggerSubmit(event)
    }
  }

  const showAddon = (type === 'password' && value && addon)
    || (type !== 'password' && addon)

  const errorMessage = error || validationError

  return (
    <StyledFormInputContainer style={overrideStyles} className={overrideClassName}>
      {label && value && <StyledInputLabel isActive={isActive}>{label}</StyledInputLabel>}
      <StyledFieldInput
        as={type === 'select' ? type : 'input'}
        type={type}
        placeholder={placeholder || label}
        value={value}
        onChange={onChange}
        name={name}
        onBlur={validateField}
        onFocus={() => highlightInput(true)}
        required={required}
        error={error}
        onKeyPress={onkeyPressed}
        updateFormError={updateFormError}
        showAddon={showAddon}
        {...input}
      >
        {props.children}
      </StyledFieldInput>

      {errorMessage && (
        <StyledParagraph
          style={{
            fontSize: '12px',
            lineHeight: '18px',
            letterSpacing: '0.4px',
            color: theme.colors.red,
            left: '16px',
            top: '100%',
            margin: 0,
            position: 'absolute',
            fontWeight: 'unset'
          }}
        >
          {errorMessage}
        </StyledParagraph>
      )}
      {showAddon && (
        <StyledInputAddon onClick={onIconClick} onKeyPress={onkeyPressed}>
          {addon}
        </StyledInputAddon>
      )}
    </StyledFormInputContainer>
  )
}

StyledInputField.defaultProps = {
  placeholder: '',
  label: '',
  error: '',
  input: {},
  type: 'text',
  required: false,
  addon: null,
  updateFormError: () => { },
  triggerSubmit: () => { }
}

StyledInputField.propTypes = {
  overrideStyles: PropTypes.shape({}),
  overrideClassName: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  input: PropTypes.shape({}),
  validate: PropTypes.arrayOf(PropTypes.func),
  addon: PropTypes.node,
  onIconClick: PropTypes.func,
  updateFormError: PropTypes.func,
  triggerSubmit: PropTypes.func
}
